import dayjs from 'dayjs';
import { ModuleFormState } from '../modules/bible-studies/bible-study-form';
import { EventFormState } from '../modules/events/containers/EventFormContainer';
import { isValidHttpUrl } from './is-url';
import { determineMimeType, sizeLimitByType } from './mimetype-utilities';

export const validateEventFormState = (form: EventFormState) => {
  if (!form.title || !form.description) {
    return 'Event cannot be saved without a Title and Description';
  }
  if (
    (form.startTime && dayjs(form.startTime).isBefore(new Date())) ||
    (form.endTime && dayjs(form.endTime).isBefore(new Date()))
  ) {
    return 'Event start/end time cannot be before the current date';
  }
  if (!form.program) {
    return 'Event cannot be saved until linked to a Study Program';
  }
  if (!form.leaderId) {
    return 'Event cannot be saved without an Event Leader';
  }
  if (!form.vimeoEventUrl) {
    return 'Event cannot be saved without an event URL';
  }
  if (!isValidHttpUrl(form.vimeoEventUrl)) {
    return 'The URL you entered is not a valid HTTP URL';
  }
};

/**
 * Checks [arr] for duplicates of [value]
 *
 * @param arr array of strings to check duplicates from
 * @param value value to check if there is a duplicate in array
 */
export const isDuplicated = (arr: string[], value: string) => {
  return arr.findIndex(tag => value.toLowerCase() === tag.toLowerCase()) !== -1;
};

export const validateModuleFormState = (moduleForm: ModuleFormState) => {
  if (!moduleForm.weekTag) {
    return 'You must set a week tag';
  }
  if (!moduleForm.dayTag) {
    return 'You must set a day tag';
  }
  if (!moduleForm.title) {
    return 'Module must have a title';
  }
  if (!moduleForm.type) {
    return 'Please choose a module type';
  }
  if (moduleForm.type !== 'scripture' && moduleForm.type !== 'qanda' && moduleForm.type !== 'text' && !moduleForm.url) {
    console.log('type: ' + moduleForm.type);
    console.log('url: ' + moduleForm.url);
    return 'Module must have a selected file';
  }
  if (moduleForm.type === 'text' && !moduleForm.content) {
    return 'Text module must have content';
  }
  if (
    (moduleForm.type === 'scripture' || (moduleForm.type === 'qanda' && moduleForm.scriptureVisible)) &&
    !moduleForm.scriptures?.length
  ) {
    return 'Scripture Module must have scriptures';
  }
  if (moduleForm.type === 'qanda') {
    if (!moduleForm.questionAndAnswers?.length) {
      return 'Q&A Module must have at least 1 question';
    } else if (moduleForm.questionAndAnswers.some(qa => !qa.question)) {
      return 'Q&A Module must have a valid question';
    }
  }
  if (
    (moduleForm.type === 'scripture' || (moduleForm.type === 'qanda' && moduleForm.scriptureVisible)) &&
    (moduleForm.translationId === null || moduleForm.translationId === '')
  ) {
    return 'Scripture Module must have bible version selected';
  }
};

export const validateFileSize = (file: File) => {
  const mbToByte = 1e6; // byte -> megabyte, divide the digital storage value by 1e+6
  const fileSizeInMb = file.size / mbToByte;
  const mimeType = determineMimeType(file.type);
  const fileSizeLimit = sizeLimitByType[mimeType];

  // validate if file exceeds max size
  if (fileSizeInMb > fileSizeLimit) {
    return `File exceeds maximum file size of ${fileSizeLimit}MB.`;
  }
};
